import { render, staticRenderFns } from "./ggAccount.vue?vue&type=template&id=d8674dd2&scoped=true"
import script from "./ggAccount.vue?vue&type=script&lang=js"
export * from "./ggAccount.vue?vue&type=script&lang=js"
import style0 from "./ggAccount.vue?vue&type=style&index=0&id=d8674dd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8674dd2",
  null
  
)

export default component.exports